export default "__VITE_ASSET__DVI8JeRc__"